<template>
  <div class="route-card-wrapper h-100">
    <div class="card h-100 border-0 shadow-sm" @click="viewDetail(route)">
      <!-- Card Header: Status and Type -->
      <div class="card-header-custom d-flex justify-content-between align-items-center p-3">
        <span class="badge badge-pill text-white" :class="statusBadgeClass" style="color:white !important">
          {{ route.status_service.name }}
        </span>
        <span class="route-type text-muted small font-weight-bold">
          <v-icon name="random" scale="0.8" class="mr-1 text-primary"></v-icon> {{ route.type_route.name }}
        </span>
      </div>

      <div class="card-body pt-0 px-4 pb-4">
        <!-- Date Header -->
        <div class="date-header mb-3 text-center">
          <span class="text-muted small">{{ humanDate(route.created_at) }}</span>
        </div>

        <!-- Passenger Info -->
        <div class="d-flex align-items-center mb-4">
          <div class="avatar-wrapper mr-3">
            <img
              v-if="route.children && route.children.url_image"
              :src="route.children.url_image"
              class="img-fluid rounded-circle h-100 w-100"
              style="object-fit: cover;"
              alt="Passenger"
            />
            <div v-else class="avatar-placeholder rounded-circle">
              <v-icon name="user" scale="1.2" class="text-muted"></v-icon>
            </div>
          </div>
          <div>
            <h5 class="passenger-name mb-0">{{ route.children ? route.children.full_name : 'Pasajero' }}</h5>
            <div class="days-indicator mt-1">
              <span v-for="(day, index) in days" :key="index" 
                class="day-badge" 
                :class="{ 'active': route.route['frecuency_day_' + (index + 1)] == 1 }">
                {{ day }}
              </span>
            </div>
          </div>
        </div>

        <!-- Route Timeline -->
        <div class="route-timeline mb-4">
          <div class="timeline-item origin">
            <div class="timeline-icon">
              <v-icon name="circle" scale="0.6" class="text-orange"></v-icon>
            </div>
            <div class="timeline-content">
              <p class="location-label mb-0">Origen</p>
              <p class="location-name text-truncate mb-0">{{ route.route && route.route.current_location ? route.route.current_location.name : 'No definido' }}</p>
            </div>
          </div>
          <div class="timeline-line"></div>
          <div class="timeline-item destination">
            <div class="timeline-icon">
              <v-icon name="map-marker-alt" scale="0.8" class="text-primary"></v-icon>
            </div>
            <div class="timeline-content">
              <p class="location-label mb-0">Destino</p>
              <p class="location-name text-truncate mb-0">{{ route.route && route.route.location ? route.route.location.name : 'No definido' }}</p>
            </div>
          </div>
        </div>

        <div class="divider mb-3"></div>

        <!-- Driver Info -->
        <div class="driver-footer d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="driver-avatar-container mr-2">
              <img
                v-if="route.driver && route.driver.url_image"
                :src="route.driver.url_image"
                class="driver-avatar rounded-circle"
                alt="Driver"
                style="width: 32px; height: 32px; object-fit: cover;"
              />
              <div v-else class="driver-avatar-placeholder rounded-circle d-flex align-items-center justify-content-center bg-light" style="width: 32px; height: 32px;">
                <v-icon name="user-tie" scale="0.7" class="text-muted"></v-icon>
              </div>
            </div>
            <div class="driver-info">
              <p class="driver-name mb-0">{{ route.driver ? route.driver.full_name : 'Conductora' }}</p>
              <p class="driver-label mb-0">Conductora</p>
            </div>
          </div>
          <div class="route-code">
            <span class="badge badge-light px-2 py-1">#{{ route.service_code }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'RouteCard',
  props: {
    route: {
      type: Object
    }
  },
  data() {
    return {
      days: ['L', 'M', 'M', 'J', 'V', 'S', 'D']
    }
  },
  computed: {
    statusBadgeClass() {
      const statusId = this.route.id_status_service
      switch (statusId) {
        case 1: return 'badge-info' // Pendiente
        case 2: return 'badge-primary' // En curso
        case 3: return 'badge-success' // Finalizada
        case 4: return 'badge-danger' // Cancelada
        default: return 'badge-secondary'
      }
    }
  },
  methods: {
    humanDate(date) {
      //Format in legible date
      moment.locale('es')
      return moment(date).format('dddd DD [de] MMMM [de] YYYY')
    },
    viewDetail(service) {
      if (service && service.id) {
        console.log("Navigating to service detail with ID:", service.id)
        this.$router.push({ name: 'ServiceDetail', params: { id: service.id } })
      } else {
        console.error("Invalid service object or missing ID:", service)
      }
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.08) !important;
}

.card-header-custom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

.avatar-wrapper {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background: #f7fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0aec0;
}

.passenger-name {
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
}

.day-badge {
  display: inline-block;
  font-size: 0.65rem;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  background: #edf2f7;
  color: #718096;
  border-radius: 4px;
  margin-right: 3px;
  font-weight: bold;
}

.day-badge.active {
  background: #f76e2a;
  color: white;
}

.route-timeline {
  position: relative;
  padding-left: 24px;
}

.timeline-line {
  position: absolute;
  left: 6px;
  top: 15px;
  bottom: 15px;
  width: 2px;
  background: #edf2f7;
  z-index: 1;
}

.timeline-item {
  position: relative;
  z-index: 2;
}

.timeline-icon {
  position: absolute;
  left: -24px;
  top: 4px;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.origin .timeline-icon { color: #f76e2a; font-size: 8px; }
.destination .timeline-icon { color: #3182ce; font-size: 14px; }

.location-label {
  font-size: 0.7rem;
  color: #a0aec0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.location-name {
  font-size: 0.85rem;
  font-weight: 500;
  color: #4a5568;
}

.divider {
  height: 1px;
  background: #f1f5f9;
}

.driver-name {
  font-size: 0.8rem;
  font-weight: 600;
  color: #2d3748;
}

.driver-label {
  font-size: 0.7rem;
  color: #a0aec0;
}

.route-code .badge {
  color: #718096;
  font-weight: 500;
  letter-spacing: 0.5px;
}
</style>
